import styled from 'styled-components'
import { Divider } from 'antd'

export default styled(Divider)`
  .ant-divider-inner-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }

  &.ant-divider-with-text-left::before {
    width: 0 !important;
  }
`
